import type { OrganizationSettings } from '@scrambl/shared'
import {
  OrganizationSessionSecuritySettingsSchema,
  SessionSecurityModeEnum,
} from '@scrambl/shared'

export interface SessionInactivityPolicy {
  enabled: boolean
  timeoutMs: number
}

/**
 * Fail open while settings are unavailable. Applying a factory timeout before
 * the selected tenant has loaded could end a continuous-session workspace.
 */
export function resolveSessionInactivityPolicy(
  settings: OrganizationSettings | undefined,
): SessionInactivityPolicy {
  if (!settings) return { enabled: false, timeoutMs: 0 }
  const parsed = OrganizationSessionSecuritySettingsSchema.safeParse(
    settings.general?.sessionSecurity ?? {},
  )
  if (!parsed.success || parsed.data.mode !== SessionSecurityModeEnum.HIPAA)
    return { enabled: false, timeoutMs: 0 }
  return {
    enabled: true,
    timeoutMs: parsed.data.inactivityTimeoutMinutes * 60 * 1000,
  }
}

export function hasSessionExpired(
  lastActivityAt: number,
  timeoutMs: number,
  now = Date.now(),
): boolean {
  return timeoutMs > 0 && now - lastActivityAt >= timeoutMs
}
